import React from "react";
import { node, bool, string, oneOf } from "prop-types";
import { classes } from "../utils/classes";

const Navbar = ({ nav, type = null, className = "", children, inverted, ...props }) => (
	<ul
		className={classes(
			"nav",
			nav && `${nav}-nav`,
			type && `nav-type-${type}`,
			inverted && "nav--inverted",
			className,
		)}
		{...props}
	>
		{children}
	</ul>
);

Navbar.propTypes = {
	nav: oneOf(["primary", "secondary"]).isRequired,
	type: oneOf([1]),
	className: string,
	children: node,
	inverted: bool,
};

export default Navbar;
